export default __webpack_public_path__ + "static/media/rates.582f3c4f.png";